import React from 'react'
import {
  Box,
  Button,
  CircularProgress,
  DialogContent,
  Dialog,
  DialogContentText,
  Typography,
} from '@material-ui/core'

interface LoadingModalProps {
  open: boolean
  value: number
  onCancel?: () => void
}

export const LoadingModal = ({ open, value, onCancel }: LoadingModalProps) => {
  return (
    <Dialog fullWidth open={Boolean(open)} aria-labelledby="loading-progress" onClose={() => onCancel?.()}>
      <DialogContent>
        <Box display="flex" justifyContent="center" p={8}>
          <Box position="relative" display="inline-flex">
            <CircularProgress variant="determinate" value={value} size={60} thickness={5} />
            <Box
              top={0}
              left={0}
              bottom={0}
              right={0}
              position="absolute"
              display="flex"
              alignItems="center"
              justifyContent="center"
            >
              <Typography variant="caption" component="div" color="textSecondary">{`${Math.round(
                value
              )}%`}</Typography>
            </Box>
          </Box>
        </Box>
        <DialogContentText align="center" id="alert-dialog-description">
          Preparing to print...
        </DialogContentText>
        <Box display="flex" justifyContent="right">
          <Button onClick={() => onCancel?.()}>Cancel</Button>
        </Box>
      </DialogContent>
    </Dialog>
  )
}
